<template>
  <div>
    <table class="center">
      <tbody class="report-container">
        <v-card-text class="pt-0">
          <v-data-table :headers="headers" :items="Invoices" hide-actions>
            <template slot="items" slot-scope="props">
              <tr :key="props.index" class="pointer" @click="viewInvoice(props.item)">
                <td class="text-xs-left">
                  <div>{{ props.item.createdAt | moment('MM/DD/YY hh:mm A') }}</div>
                  <div v-if="props.item.VehicleInvoice" style="color: #3CAA9E">
                    -
                    <span v-if="props.item.VehicleInvoice.ContactVehicle.year">{{
                      props.item.VehicleInvoice.ContactVehicle.year
                    }}</span>
                    <span v-if="props.item.VehicleInvoice.ContactVehicle.make">
                      {{ props.item.VehicleInvoice.ContactVehicle.make }}</span
                    >
                    <span v-if="props.item.VehicleInvoice.ContactVehicle.model">
                      {{ props.item.VehicleInvoice.ContactVehicle.model }}</span
                    >
                  </div>
                </td>

                <td class="pl-0 pr-0">
                  <!-- <InvoiceStatus :status="props.item.closed" /> -->
                </td>

                <td class="text-xs-left">
                  <div>
                    <span>{{ props.item.localId }}</span>
                    <v-chip
                      small
                      text-color="#5E687B"
                      color="#DFE4EB"
                      v-if="props.item.metadata && props.item.metadata.signature"
                    >
                      <v-icon small color="#5E687B">fas fa-signature</v-icon>
                    </v-chip>
                  </div>
                  <div>
                    {{ props.item.Employee.name }}
                  </div>
                </td>

                <td class="text-xs-left text-capitalize">
                  <div v-if="props.item.Contact">
                    <span> {{ props.item.Contact.fullName }}</span>
                  </div>
                  <div v-else>Walk-in customer</div>
                  <div v-if="props.item.Contact && props.item.Contact.phoneNumber">
                    <span>{{ props.item.Contact.phoneNumber }}</span>
                  </div>
                </td>

                <td class="text-xs-right" v-if="subTax">
                  {{
                    (parseFloat(props.item.subTotal) + parseFloat(props.item.taxTotal)) | currency
                  }}
                </td>

                <td class="text-xs-right" v-if="discount">
                  {{ props.item.discountTotal | currency }}
                </td>
                <td class="text-xs-right" v-if="taxCollected">
                  {{ props.item.taxTotal | currency }}
                </td>
                <td class="text-xs-right" v-if="paymentTotal">
                  {{ props.item.paymentTotal | currency }}
                </td>
                <td class="text-xs-right" v-if="subTotal">{{ props.item.subTotal | currency }}</td>
                
                <td class="text-xs-right" v-if="grandTotal">
                  {{ props.item.grandTotal | currency }}
                </td>
                <td class="text-xs-right" v-if="dueAmount">
                  <span :class="{ 'red--text': props.item.dueAmount !== 0 }">{{
                    props.item.dueAmount | currency
                  }}</span>
                </td>
                <td class="text-xs-right" v-if="cash">{{ props.item.payment.cash | currency }}</td>
                <td class="text-xs-right" v-if="credit">
                  {{ props.item.payment.credit | currency }}
                </td>
                <td class="text-xs-right" v-if="other">
                  {{ props.item.payment.other | currency }}
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td :colspan="headers.length - minus">
                  <div class="text-xs-right font-weight-bold">{{ $t('labels.total') }}</div>
                </td>
                <td class="text-xs-right font-weight-bold" v-if="subTax">
                  {{ unGroupSubTax_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="discount">
                  {{ unGroupDiscount_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="taxCollected">
                  {{ unGroupTax_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="paymentTotal">
                  {{ unGroupPayment_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="subTotal">
                  {{ unGroupSubTotal_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="grandTotal">
                  {{ unGroupGrandTotal_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="dueAmount">
                  {{ unGroupDueAmount_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="cash">
                  {{ unGroupCash_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="credit">
                  {{ unGroupCredit_total | currency }}
                </td>
                <td class="text-xs-right font-weight-bold" v-if="other">
                  {{ unGroupOther_total | currency }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </tbody>
    </table>
    <v-dialog v-model="invoiceDialog" transition="false" width="500">
      <!-- <InvoiceReceipt
        v-if="invoiceDialog"
        :offsety="120"
        :invoice="Invoice"
        :actions="true"
        :showTitle="true"
        :smallScreen="true"
        @close="invoiceDialog = false"
      ></InvoiceReceipt> -->
    </v-dialog>
  </div>
</template>

<script>
//import InvoiceStatus from '@/components/InvoiceStatus';
import invoiceService from '@/modules/Invoice/service.js';

//const InvoiceReceipt = () => import('@/modules/Receipts/Invoice.vue');

export default {
  props: [
    'compact',
    'taxCollected',
    'discount',
    'paymentTotal',
    'Invoices',
    'subTax',
    'subTotal',
    'grandTotal',
    'other',
    'credit',
    'cash',
    'dueAmount',
    'other',
  ],
  data() {
    return {
      invoiceDialog: false,
      Invoice: null,
      minus: 0,
      isLoading: true,
      headers: [
        {
          text: this.$t('labels.date'),
          align: 'left',
          sortable: false,
          value: 'createdAt',
          width: '15%',
        },
        {
          text: null,
          value: 'status',
        },
        {
          text: this.$t('labels.invoice'),
          align: 'left',
          sortable: false,
          value: 'localId',
        },
        {
          text: this.$t('labels.customer'),
          value: 'fullName',
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    if (this.subTax) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.amount'),
        value: 'subTax',
        align: 'right',
        sortable: false,
      });
    }

    if (this.discount) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.amount'),
        value: 'discount',
        align: 'right',
        sortable: false,
      });
    }

    if (this.taxCollected) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.taxCollected'),
        value: 'paymentTotal',
        align: 'right',
        sortable: false,
      });
    }

     if (this.paymentTotal) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.payment'),
        value: 'paymentTotal',
        align: 'right',
        sortable: false,
      });
    }

    

    if (this.subTotal) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.subTotal'),
        value: 'grandTotal',
        align: 'right',
        sortable: false,
      });
    }

    if (this.grandTotal) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.grandTotal'),
        value: 'grandTotal',
        align: 'right',
        sortable: false,
      });
    }

    if (this.dueAmount) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.dueAmount'),
        value: 'dueAmount',
        align: 'right',
        sortable: false,
        width: '20px',
      });
    }

    if (this.cash) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.cash'),
        value: 'cash',
        align: 'right',
        sortable: false,
        width: '20px',
      });
    }

    if (this.credit) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.creditDebit'),
        value: 'creditDebit',
        align: 'right',
        sortable: false,
        width: '20px',
      });
    }

    if (this.other) {
      this.minus++;
      this.headers.push({
        text: this.$t('labels.otherPayments'),
        value: 'otherPayments',
        sortable: false,
        align: 'right',
        width: '20px',
      });
    }
  },
  computed: {
    unGroupDiscount_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.discountTotal);
      });
      return total;
    },
    unGroupSubTax_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.subTotal) + parseFloat(row.taxTotal);
      });
      return total;
    },
    unGroupTax_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.taxTotal);
      });
      return total;
    },
    unGroupPayment_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.paymentTotal);
      });
      return total;
    },
    unGroupSubTotal_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.subTotal);
      });
      return total;
    },
    unGroupGrandTotal_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.grandTotal);
      });
      return total;
    },
    unGroupDueAmount_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.dueAmount);
      });
      return total;
    },
    unGroupCash_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.payment.cash);
      });
      return total;
    },
    unGroupCredit_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.payment.credit);
      });
      return total;
    },
    unGroupOther_total() {
      let total = 0;
      this.Invoices.map(row => {
        total += parseFloat(row.payment.other);
      });
      return total;
    },
  },
  components: {
    // InvoiceStatus,
    // InvoiceReceipt,
  },
  methods: {
    viewInvoice(invoice) {
      invoiceService.getById(invoice.id).then(response => {
        this.Invoice = response.data;
        this.invoiceDialog = true;
      });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
